import React, { FunctionComponent } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const CaptchaWrapper: FunctionComponent = ({ children }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={
      process.env.NODE_ENV === 'development'
        ? '6LcIkngfAAAAALh9_CJPs33aNEO5YvT0Kmy8pYiw'
        : '6Lebj3gfAAAAAB_jIVAyi8T4J0G1EtGQCrPVipUH'
    }
  >
    {children}
  </GoogleReCaptchaProvider>
);

export default CaptchaWrapper;
